import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

/**
 * Paginator UI strings sourced from the translation files;
 * refreshed on every language change.
 */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
    this.updateLabels();
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
      this.changes.next();
    });
  }

  private updateLabels(): void {
    const instant = (key: string): string => this.translate.instant(`material.paginator.${key}`);
    this.itemsPerPageLabel = instant('itemsPerPage');
    this.firstPageLabel = instant('firstPage');
    this.previousPageLabel = instant('previousPage');
    this.nextPageLabel = instant('nextPage');
    this.lastPageLabel = instant('lastPage');
    this.getRangeLabel = (page, pageSize, length) => {
      if (length === 0) {
        return this.translate.instant('material.paginator.range', { start: 0, end: 0, total: 0 });
      }
      const start = page * pageSize + 1;
      const end = Math.min((page + 1) * pageSize, length);
      return this.translate.instant('material.paginator.range', { start, end, total: length });
    };
  }
}
